import React from 'react';
import { Icon, IconName } from '../../assets/icons';
import styles from '../styles/menu.module.scss';
import { Link, useLocation } from 'react-router-dom';

interface SidebarItemProps {
  icon: IconName;
  text: string;
  to?: string;
  color?: string; // color de fondo opcional para proyectos
  badge?: 'dot' | string;
  active?: boolean;
  onClick?: () => void;
}

export const SidebarItem: React.FC<SidebarItemProps> = ({
  icon,
  text,
  to,
  color,
  badge,
  active,
  onClick,
}) => {
  const location = useLocation();
  const isActive = typeof to === 'string' && location.pathname === to;
  const content = (
    <div
      className={[
        styles.sidebarItem,
        (active || isActive) ? styles.active : '',
        color ? styles.colored : '',
      ].filter(Boolean).join(' ')}
      style={color ? { background: color } : {}}
      onClick={onClick}
      tabIndex={0}
      role="button"
    >
      <span className={styles.iconWrapper}>
        <Icon name={icon} />
      </span>
      <span className={styles.text}>{text}</span>
      {badge === 'dot' && <span className={styles.badgeDot} />}
      {badge && badge !== 'dot' && <span className={styles.badge}>{badge}</span>}
    </div>
  );
  return to ? <Link to={to} className={styles.sidebarLink}>{content}</Link> : content;
};

export default SidebarItem; 